import { Check } from "lucide-react";
import React from "react";
import { AiOutlineCheck } from "react-icons/ai"; // Import the checkmark icon
import Checkbox from "../Checkbox";

const CheckboxInput = ({
  label = "I agree to the terms and conditions", // Default label for "I agree"
  checked,
  onChange,
  className = "",
  labelClassName = "",
  checkboxClassName = "",
  disabled = false, // Added disabled prop
}) => {
  return (
    <div className={`w-full flex items-center gap-2 ${className}`}>
      <div
        className={`relative flex items-center justify-center w-4 h-4 border-2 border-secondary/20 rounded-sm ${
          disabled
            ? "cursor-not-allowed bg-secondary/35 border-secondary/20"
            : checked
            ? "bg-primary border-primary"
            : "bg-transparent"
        } ${checkboxClassName}`}
      >
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        {checked && <AiOutlineCheck className="text-secondary text-lg" />}
      </div>
      <span
        className={`text-body1 font-ptsans items-center ${
          disabled ? "text-secondary/35" : "text-secondary/60"
        } ${labelClassName}`}
      >
        {label}
      </span>
    </div>
  );
};

export default CheckboxInput;
